<template>
  <el-col :span="24" ref="trxContainer">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="isSaving && isSaveable ? 7 : 12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100; display: inline-block;">NEW PETTY CASH ENTRY</h2>
        </el-row>
      </el-col>
      <el-col :span="11" v-if="isSaving && isSaveable">
        <TransactionProgressBar
          :totalRequests="totalRequests"
          :completedRequests="completedRequests"
          :error="(!!failedLines.length)"
        />
      </el-col>
      <DataEntryButtons
        :isSaveable="isSaveable"
        :isOpenable="isOpenable"
        :isBalanced="transactionIsBalanced"
        :isSaving="isSaving"
        :transactionType="transactionType"
        :hasPermission="hasPermission"
        @goBack="goBack"
        @submit="submitForm"
        @otherActions="otherActions"
        @dropdownClick="handleDropdownClick"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
    <el-row justify="start" align="start" type="flex" class="trx-header" ref="trxHeaderContainer">
      <el-col :span="8" style="margin-right: 10px">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Vendor"
            :fields="fields.vendor"
            :form="form"
            :idPrefix="'a-'"
            :modalOpen="dialogVisible"
            :specialCellDisplayValue="vendorOpenPOs"
            :specialCellBtnLabel="fetchingPoData ? 'Loading...' : 'Import PO Lines'"
            :linesContainReliefLines="linesContainReliefLines"
            :isSaving="isSaving"
            @specialCellBtnClick="handleImportPoDialogVisible(true)"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            :form="form"
            :idPrefix="'b-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="margin: 0 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Petty Cash Data"
            :fields="fields.pcData"
            :form="form"
            :idPrefix="'c-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
            :key="effectiveDateMandatory"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="margin-left: 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Info"
            :fields="fields.transactionInfo"
            :lines="lines"
            :idPrefix="'d-'"
            :isSaving="isSaving"
            :modalOpen="dialogVisible"
          />
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded"
        entityType="pc"
        :fields="lineFields"
        :lines="lines"
        :vendorPoLines="vendorPoLines"
        :initLines="20"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :reset="resetLines"
        :fetchingPoLines="fetchingPoData"
        ref="distribution-lines"
        :readOnly="isSaving"
        :fieldsToClear="lineFieldsToClear"
        :hasEditPermission="hasEditPermission"
        @lineChanged="trackLineChanges"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @hasBeenReset="linesHaveBeenReset"
        @updateLines="updateLines"
        @mounted="setBatchAttributeLineValues"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      :visible.sync="dialogVisible"
      size="tiny"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>Do you wish to save this transaction as a draft?</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="exit-modal-btn"
          :disabled="isSaving"
          @click="cancelExit">
          Cancel
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          :disabled="isSaving"
          @click="goBack(true)">
          No
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          :disabled="isSaving"
          :loading="isSaving"
          @click="submitForm(false, null, true)">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <RouteChangeDialog :visible="showExitWarningDialog" @isVisible="handleExitWarningDialogVisible" @confirm="goBack(true)" />
    <NewBatch :hasCreatePermission="userCanCreateBatch" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <el-dialog
      title="Select PO Lines to Import"
      :visible.sync="importPoDialogVisible"
      size="large"
      id="el-dialog-pos-table"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <el-row type="flex" justify="end" align="middle" v-if="!fetchingPoData" style="z-index: 2010; bottom: 20px;">
        <el-button @click="handleImportPoDialogVisible(false)">
          Cancel
        </el-button>
        <el-button
          type="primary"
          :disabled="!selectedPoLines.length"
          @click="importPoLines">
          Done
        </el-button>
      </el-row>
      <div style="padding: 0 20px;">
        <el-row type="flex" align="middle" justify="center">
          <el-table
            v-loading="fetchingPoData"
            element-loading-text="Loading POs and related lines"
            id="import-po-table"
            :data="filterPoList(poList)"
            border
            default-expand-all
            :row-key="getRowKey"
            ref="importPoCarousel">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  :id="'po-lines-table_' + Math.floor(Math.random() * 10000 + 1)"
                  :data="filterPoLines(props.row.lines)"
                  border
                  :row-key="getRowKey"
                  @selection-change="selectPoLines(props.row, $event)"
                  :ref="'importPoLinesTable_' + Math.floor(Math.random() * 10000 + 1)"
                >
                  <el-table-column type="selection" :key="getRowKey" width="55" align="center" :reserve-selection="true" />
                  <el-table-column prop="line_number" label="No" width="70" />
                  <el-table-column prop="account_code" label="Account" width="130" />
                  <el-table-column prop="account_name" label="Account Name" width="200" />
                  <el-table-column prop="meta_name" label="Description" />
                  <el-table-column prop="amount_decimal" label="Amount" width="100">
                    <template #default="scope">
                      {{ formatAmountLocale(scope.row.amount_decimal) }} 
                    </template>
                  </el-table-column>
                  <el-table-column prop="remaining_decimal" label="Remaining" width="100">
                    <template #default="scope">
                      {{ formatAmountLocale(scope.row.remaining_decimal) }}
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="No" />
            <el-table-column prop="description" label="Description" />
            <el-table-column prop="amount_decimal" label="Amount">
              <template #default="scope">
                {{ formatAmountLocale(scope.row.amount_decimal) }}
              </template>
            </el-table-column>
            <el-table-column prop="remaining" label="Remaining">
              <template #default="scope">
                {{ formatAmountLocale(scope.row.remaining) }}
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
      <el-row type="flex" justify="end" align="middle" v-if="!fetchingPoData" style="padding: 20px 0 0 0;">
        <el-button @click="handleImportPoDialogVisible(false)">
          Cancel
        </el-button>
        <el-button
          type="primary"
          :disabled="!selectedPoLines.length"
          @click="importPoLines">
          Done
        </el-button>
      </el-row>
    </el-dialog>
    <CustomerVendorForm :type="customerVendorFormType" :modelId="modelId" @updateModelIdProp="updateVendorModelId" @populateFieldWithNewModel="populateFieldWithNewModel" />
  </el-col>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew1.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import CustomerVendorForm from '@/components/FormComponents/CustomerVendorForm.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import RouteChangeDialog from '@/components/RouteChangeDialog.vue'
  import { isPcBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { pettycashMixins } from '@/Mixins/PettyCash'
  import { transactionCreateViewMixins } from '@/Mixins/TransactionCreateViews'
  import { vendorMixins } from '@/Mixins/VendorMixins'
  import LinesLoading from '@/components/LinesLoading.vue'
  import TransactionProgressBar from '@/components/TransactionProgressBar.vue'
  import { getSimpleDate } from '@/utils/helpers/FormatDate'
  import store from '@/store/store'
  import { formatAmount } from '@/utils/helpers/AmountFormatter'

  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      CustomerVendorForm,
      DataEntryButtons,
      RouteChangeDialog,
      TransactionProgressBar,
      LinesLoading
    },
    mixins: [ transactionMixins, transactionCreateViewMixins, pettycashMixins, vendorMixins ],
    data () {
      const batch = this.setFormBatch()
      return {
        modelId: null,
        transactionType: { name: 'pc', path: '/pettycash/', prettyName: 'Petty Cash' },
        form: {
          batch: { label: batch ? batch.name : '', value: batch ? batch.id : '' },
          period: '',
          vendor: { label: '', value: '' },
          number: '',
          description: '',
          date: getSimpleDate(new Date(), 'yyyy-mm-dd'),
          amount_decimal: '',
          advanced_amount_decimal: '0.00',
          reimbursed_amount_decimal: '0.00',
          amount_beginning_pc_decimal: '',
          amount_remaining_pc_decimal: '',
          pcAccount: '',
          cashAccount: '',
          effective_date: '',
          lines: []
        },
        effectiveDateMandatory: false,
        importPoDialogVisible: false,
        selectedPoLines: [],
        notificationBox: undefined,
        specialPcLines: {
          envelope: undefined,
          advance: undefined,
          reimbursement: undefined
        },
        fetchingPoData: false,
        autoEnterLineLimit: 3 // when adding default values like account, tax code
      }
    },
    methods: {
      formatAmountLocale (value) {
        return formatAmount(value)
      },
      /**
       * Updates modelId prop passed to customer create/edit modal
       */
      updateVendorModelId (id) {
        this.modelId = id
      },
      /**
       * Updates header form
       */
      updateForm (form, changedField = null) {
        this.form = form
        if (changedField === 'vendor') {
          if (this.linesContainReliefLines) {
            this.clearLineFields(['relieves'])        // check if vendor field was cleared, and if so, clear 'relieves' field in DistributionLines
            this.currentVendorSelection = ''
            this.fetchingPoData = false
          }
          if (this.form.vendor.value) {
            this.currentVendorSelection = this.form.vendor.value
          }
        } else if (changedField === 'batch') {
          this.setBatchAttributeLineValues(this.batchAttributes)
          this.setPcBalance(this.form.vendor.value, true)     // set selected batch's bank cash account
          if (this.advanced_amount) {
            this.addAdvanceLineItem()
          }
        }

        this.transactionIsBalanced = isPcBalanced(this)
        this.trackHeaderChanges()
        this.isSaveable = this.checkIfCanBeSaved()
        this.isOpenable = this.transactionIsBalanced && this.checkIfCanBeSaved()
      },
      /**
       * Updates lines
       * @param lines
       */
      updateLines (lines) {
        if (lines) {
          this.lines = lines
          this.transactionIsBalanced = isPcBalanced(this)
          this.isSaveable = this.checkIfCanBeSaved()
          this.isOpenable = this.transactionIsBalanced && this.checkIfCanBeSaved()
        }
      },
      /**
       * Resets the header form and component to initial state
       */
      resetForm () {
        const batch = this.setFormBatch(this.form.batch.value)
        const form = {
          batch: { label: batch ? batch.name : '', value: batch ? batch.id : '' },
          period: { label: '', value: '' },
          vendor: { label: '', value: '' },
          number: '',
          description: '',
          date: getSimpleDate(new Date(), 'yyyy-mm-dd'),
          amount_decimal: '',
          effective_date: this.effectiveDateMandatory ? getSimpleDate(new Date(), 'yyyy-mm-dd') : ''
        }
        this.form = { ...form }
        this.lineFieldsToClear = []
        this.currentVendorSelection = ''
        this.poList = []
      },
      /**
       * Governs visibility of the "Import PO" modal
       */
      handleImportPoDialogVisible (visible) {
        if (visible) this.getPoList()
        this.importPoDialogVisible = visible
      },
      getRowKey (row) {
        return row.id
      },
      /**
       * Handles selecting PO lines in the importPoDialog
       * @param lines   The selected PO lines
       */
      selectPoLines (transaction, lines) {
        this.selectedPoLines = this.selectedPoLines.filter((v) => v.transaction_id !== transaction.id)
        if (lines.length) {
          this.selectedPoLines = [...this.selectedPoLines, ...lines]
        }
      },
      /**
       * Checks if the user has already entered lines and if so, gets the indexes of the next available lines
       */
      importPoLines () {
        const selectedPoLines = [...new Set(this.selectedPoLines)]
        // get po line accounts
        const selectedPoLinesAccounts = selectedPoLines.map(v => v.account)
        this.$store.dispatch('fetchAccountsWithQuery', { id__in: [...new Set(selectedPoLinesAccounts)], page_size: selectedPoLinesAccounts.length })

        const getCode = (id, getter) => {
          let model
          if (typeof this.$store.getters[getter] === 'function') {
            model = this.$store.getters[getter](id)
          }
          return model && model.code ? model.code : ''
        }
        const setAmountDecimal = (line) => {
          if (line && line.hasOwnProperty('amount_decimal') && parseFloat(line.amount_decimal) < 0 && line.hasOwnProperty('remaining_decimal') && parseFloat(line.remaining_decimal) === 0) {
            return line.amount_decimal
          } else if (line && line.hasOwnProperty('remaining_decimal')) {
            return line.remaining_decimal
          } else if (line && !line.hasOwnProperty('remaining_decimal') && line.hasOwnProperty('amount_decimal')) {
            return line.amount_decimal
          }
          return ''
        }
        selectedPoLines.forEach(l => {
          let poLineAccount = ''
          if (l.account && l.account_code) {
            poLineAccount = { label: l.account_code, value: l.account }
          } else {
            poLineAccount = { label: getCode(l.account, 'getAccountById'), value: l.account }
          }
          let form = {
            relieves: l.hasOwnProperty('meta_name') ? { label: l.meta_name, value: l.id } : '',
            description: l.description || '',
            other_name: l.other_name || '',
            amount_decimal: setAmountDecimal(l),
            asset: !!l.asset,
            account: poLineAccount,
            series: { label: getCode(l.series, 'getSeriesById'), value: l.series || '' },
            location: { label: getCode(l.location, 'getLocationById'), value: l.location || '' },
            set: { label: getCode(l.set, 'getSetById'), value: l.set || '' },
            tax_code: { label: getCode(l.tax_code, 'getTaxcodeById'), value: l.tax_code || '' },
            free_field_1: { label: getCode(l.free_field_1, 'getFreefieldById'), value: l.free_field_1 || '' },
            free_field_2: { label: getCode(l.free_field_2, 'getFreefieldById'), value: l.free_field_2 || '' },
            free_field_3: { label: getCode(l.free_field_3, 'getFreefieldById'), value: l.free_field_3 || '' },
            free_field_4: { label: getCode(l.free_field_4, 'getFreefieldById'), value: l.free_field_4 || '' },
            third_party_vendor: { label: getCode(l.third_party_vendor, 'getVendorById'), value: l.third_party_vendor || '' },
            is_offset: false
          }
          // Why oh why are we using this instead of fillFieldsWithPoLineData
          // hacking the necessary functionality instead
          this.$store.dispatch('fetchPoLinesWithQuery', {id: l.id})
          if (this.$refs['distribution-lines'].addExistingLine &&
            typeof this.$refs['distribution-lines'].addExistingLine === 'function') {
            this.$refs['distribution-lines'].addExistingLine({ line_number: null, form }, true)
          }
        })
        this.importPoDialogVisible = false
        this.selectedPoLines = []
      },
      // using computed objects to avoid watching entire form
      addEnvelopeLineItem () {
        this.specialPcLines.envelope = this.$refs['distribution-lines'].addPettyCashLines('envelope', this.specialPcLines.envelope)
      },
      addAdvanceLineItem () {
        this.specialPcLines.advance = this.$refs['distribution-lines'].addPettyCashLines('advance', this.specialPcLines.advance)
      },
      addReimbursementLineItem () {
        this.specialPcLines.reimbursement = this.$refs['distribution-lines'].addPettyCashLines('reimbursement', this.specialPcLines.reimbursement)
      },
      // Validate Envelop and Advanced amount to add distribution-lines
      validateEnvelopAndAdvancedAmount (type, addLine = 1) {
        // Get total distribution lines
        let totalDistributionLines = this.$refs['distribution-lines'].lines
        // Check all the distribution lines are filled or not
        let validateDistributionLines = this.$refs['distribution-lines'].getValidLines()
        // Check total distribution lines and validlines are equal or not
        if (totalDistributionLines && validateDistributionLines && validateDistributionLines.length === totalDistributionLines.length) {
          // Get last object info to validate a new line
          let getLastObj = totalDistributionLines[totalDistributionLines.length - 1]
          // Check description has 'PETTY CASH OFFSET' value or not
          if ((getLastObj.form.description).includes('PETTY CASH OFFSET') && type === 'envelop') return
          // Check description has 'PETTY CASH ADVANCE' value or not
          else if ((getLastObj.form.description).includes('PETTY CASH ADVANCE') && type === 'advance') return
          // Add a new line if above condtions are invalid
          else this.$refs['distribution-lines'].addNewLines(addLine)
        }
      }
    },
    computed: {
      ...mapGetters({
        getPoById: 'getPoById',
        getStateById: 'getStateById',
        getPoLines: 'getPoLines',
        getPoLineById: 'getPoLineById',
        getPoMetadata: 'getPoMetadata',
        getAccountById: 'getAccountById',
        getAccountBalanceByCode: 'getAccountBalanceByCode',
        getBankByBatchId: 'getBankByBatchId',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions'
      }),
      hasCreatePermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_pettycash', 'entry.add_pettycash'])
      },
      hasEditPermission () {
        if (!this.hasCreatePermission) return false
        else return true
      },
      userCanCreateBatch () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_batch', 'entry.add_batch'])
      },
      hasPermission () {
        return {
          create: this.hasCreatePermission,
          edit: this.hasEditPermission,
          delete: true,
          post: true
        }
      },
      fields () {
        let fields = {
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'batches' },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a batch',
                addBtn: this.userCanCreateBatch
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          vendor: {
            inputFields: [
              {
                name: 'vendor',
                label: 'Vendor',
                dataType: 'string',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'vendors', params: { active: 'True', petty_cash_enabled: 'True' } },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a vendor',
                addBtn: this.userCanCreateVendor
              }
            ],
            displayFields: [
              {
                name: 'vendor',
                label: 'Open POs',
                // value: this.vendorOpenPOs
                value: this.filterPoList(this.poList).length || '',
                specialCell: true
              },
              {
                name: 'vendor',
                label: 'Type',
                value: this.form.vendor.value ? this.getVendorById(this.form.vendor.value).entity_type : ''
              },
              {
                name: 'vendor',
                label: 'Work State',
                value: this.vendorWorkState
              }
            ]
          },
          pcData: {
            inputFields: [
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                msg: 'Please provide a description',
                min: 3
              },
              {
                name: 'number',
                label: 'Envelope Number',
                dataType: 'string',
                fieldType: 'input',
                required: true
              },
              {
                name: 'date',
                label: 'Date',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                msg: 'Please specify a date'
              },
              {
                name: 'effective_date',
                label: 'Effective Date',
                dataType: 'string',
                required: this.effectiveDateMandatory,
                fieldType: 'date'
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              },
              {
                name: 'amount_decimal',
                label: 'Envelope Amount',
                dataType: 'string',
                fieldType: 'money',
                required: true,
                isMoney: true
              },
              {
                name: 'advanced_amount_decimal',
                label: 'Advanced Amount',
                dataType: 'string',
                fieldType: 'money',
                required: false,
                isMoney: true
              },
              {
                name: 'reimbursed_amount_decimal',
                label: 'Amount to Reimburse',
                dataType: 'string',
                fieldType: 'input',
                required: false,
                hidden: true,
                isMoney: true
              },
              {
                name: 'amount_beginning_pc_decimal',
                label: 'Beginning PC Bal',
                dataType: 'string',
                fieldType: 'money',
                disabled: true,
                required: false,
                hidden: true,
                isMoney: true
              },
              {
                name: 'amount_remaining_pc_decimal',
                label: 'Remaining PC Bal',
                dataType: 'string',
                fieldType: 'money',
                disabled: true,
                required: false,
                hidden: true,
                isMoney: true
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Transaction #',
                value: ''
              },
              {
                label: 'Date created',
                value: this.formatDateToLocale(new Date())
              },
              {
                label: 'Date posted',
                value: ''
              },
              {
                label: 'Status',
                value: 'NEW'
              },
              {
                name: 'runningTotal',
                label: 'Total Distributed',
                prefix: '$'
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.pcData.inputFields[4].options.push({
            label: 'Current',
            value: this.currentPeriod.id,
            selected: true
          })
        }
        return fields
      },
      // Using computed objects to get numeric values and to watch changes without having to watch entire form
      amount_envelope () {
        if (!this.form.amount_decimal || isNaN(this.form.amount_decimal)) return 0
        else return parseFloat(this.form.amount_decimal)
      },
      advanced_amount () {
        if (!this.form.advanced_amount_decimal || isNaN(this.form.advanced_amount_decimal)) return 0
        else return parseFloat(this.form.advanced_amount_decimal)
      },
      reimbursed_amount () {
        if (!this.form.reimbursed_amount_decimal || isNaN(this.form.reimbursed_amount_decimal)) return 0
        else return parseFloat(this.form.reimbursed_amount_decimal)
      },
      amount_pc_beginning () {
        if (!this.form.amount_beginning_pc_decimal || isNaN(this.form.amount_beginning_pc_decimal)) return 0
        else return parseFloat(this.form.amount_beginning_pc_decimal)
      },
      amount_pc_balance () {
        let balance = this.amount_pc_beginning - this.amount_envelope + this.advanced_amount + this.reimbursed_amount
        return parseFloat(balance)
      }
    },
    watch: {
      currentVendorSelection () {
        if (this.currentVendorSelection) {
          this.setPcBalance(this.form.vendor.value)
          this.getPoList()
          this.setDefaultTaxcodeLineValues()
        } else {
          this.poList = []
        }
      },
      // If these fields change, update the remaining pc balance and related distribution line
      async amount_envelope (newValue, oldValue) {
        if ((newValue) || newValue === 0 || newValue === '') {
          await this.validateEnvelopAndAdvancedAmount('envelop', 1)
          this.form.amount_remaining_pc_decimal = this.amount_pc_balance.toFixed(2)
          this.addEnvelopeLineItem()
        }
      },
      async advanced_amount (newValue, oldValue) {
        if ((newValue) || newValue === 0 || newValue === '') {
          await this.validateEnvelopAndAdvancedAmount('advance', 2)
          this.form.amount_remaining_pc_decimal = this.amount_pc_balance.toFixed(2)
          this.addAdvanceLineItem()
        }
      },
      reimbursed_amount (newValue, oldValue) {
        if ((newValue) || newValue === 0 || newValue === '') {
          this.form.amount_remaining_pc_decimal = this.amount_pc_balance.toFixed(2)
          this.addReimbursementLineItem()
        }
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/PettyCash/New.vue